import { render, staticRenderFns } from "./SmartFoodSubstitutions.vue?vue&type=template&id=b675e4a6&"
import script from "./SmartFoodSubstitutions.vue?vue&type=script&lang=js&"
export * from "./SmartFoodSubstitutions.vue?vue&type=script&lang=js&"
import style0 from "./SmartFoodSubstitutions.vue?vue&type=style&index=0&id=b675e4a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports